var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"Shopping cart\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.25 18.75C6.94036 18.75 7.5 18.1904 7.5 17.5C7.5 16.8096 6.94036 16.25 6.25 16.25C5.55964 16.25 5 16.8096 5 17.5C5 18.1904 5.55964 18.75 6.25 18.75Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 18.75C15.6904 18.75 16.25 18.1904 16.25 17.5C16.25 16.8096 15.6904 16.25 15 16.25C14.3096 16.25 13.75 16.8096 13.75 17.5C13.75 18.1904 14.3096 18.75 15 18.75Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.5 4.37513H3.6375L3.125 1.75013C3.09578 1.60683 3.01724 1.47832 2.90304 1.38696C2.78884 1.2956 2.64622 1.24718 2.5 1.25013H0V2.50013H1.9875L4.375 14.5001C4.40422 14.6434 4.48276 14.7719 4.59696 14.8633C4.71116 14.9547 4.85378 15.0031 5 15.0001H16.25V13.7501H5.5125L5 11.2501H16.25C16.3945 11.2537 16.5357 11.207 16.6497 11.1181C16.7636 11.0292 16.8432 10.9036 16.875 10.7626L18.125 5.13763C18.1459 5.04489 18.1455 4.9486 18.1236 4.85608C18.1017 4.76357 18.059 4.67726 17.9987 4.60373C17.9385 4.53021 17.8622 4.4714 17.7758 4.43178C17.6894 4.39217 17.595 4.37279 17.5 4.37513ZM15.75 10.0001H4.7625L3.8875 5.62513H16.7188L15.75 10.0001Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarticon);
export default __webpack_public_path__ + "static/media/carticon.e21b7fbf15c03eeb6728ec012f6f9f5c.svg";
export { ForwardRef as ReactComponent };